import type { SoldPixel } from "./api";

/** A stored image reference; the decorative fallback image never counts. */
export function hasPixelPicture(pixel: Pick<SoldPixel, "image">): boolean {
  return typeof pixel.image === "string" && pixel.image.trim().length > 0;
}
